<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2" sm="12" cols="12">
            <Sidebar></Sidebar>
        </v-col>
        <v-col md="10" sm="12">
            <div class="headline">
                <h1 class="headline">
                    Administrative Rules
                </h1>
                <v-breadcrumbs divider=">" :items="breadcrumbs"></v-breadcrumbs>
                <v-container>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <GoogleSearchStatute></GoogleSearchStatute>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <v-divider></v-divider>
            <v-alert v-if="loading" :value="true" type="info">
                Loading Please wait
            </v-alert>
            <v-container style="text-align:center" class="px-0">
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card class="pa-2"
                                outlined
                                tile
                                @click="rulefilter = 'All'">
                            All
                        </v-card>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col sm="4" cols="12">
                        <v-card class="pa-2"
                                outlined
                                tile
                                @click="rulefilter = 'Active'">
                            Active
                        </v-card>
                    </v-col>
                    <v-col sm="4" cols="12">
                        <v-card class="pa-2"
                                outlined
                                tile
                                @click="rulefilter = 'Transferred'">
                            Transferred, Repealed, Superseded
                        </v-card>
                    </v-col>
                    <v-col sm="4" cols="12">
                        <v-card class="pa-2"
                                outlined
                                tile
                                @click="rulefilter = 'Reserved'">
                            Reserved
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <FilterableDataTable :headers="headers"
                                 :items="filteredItems"
                                 item-key="RuleId"
                                 disable-pagination
                                 :sort-desc="[false]"
                                 :loading="loading"
                                 loading-text="Loading... Please wait"
                                 hide-default-footer
                                 class="elevation-1">
                <template v-slot:item.Article="{ item }">
                    <router-link :to="'/Rules/Administrative/' + item.RuleNumber" style="text-decoration: none;">{{item.Article}}</router-link>
                </template>

                <template v-slot:item.CatchLine="{ item }">
                    <div class="hidden-md-and-up">
                        {{item.CatchLine}}
                    </div>
                    <div class="hidden-sm-and-down">
                        {{shortenCell(item.CatchLine)}}
                    </div>
                </template>
                <template v-slot:no-data>
                    <v-alert v-if="!loading" :value="true" type="info">
                        No Results
                    </v-alert>
                </template>
            </FilterableDataTable>
        </v-col>
    </v-row>
</template>
<script>
    const GoogleSearchStatute = () => import("@/Components/GoogleSearchStatute.vue");
    const Sidebar = () => import("@/Menus/Sidebar.vue");
    const FilterableDataTable = () => import("@/Components/FilterableDataTable.vue");

    export default {
        name: 'AdminRules',
        props: [],
        components: {
            GoogleSearchStatute,
            Sidebar,
            FilterableDataTable
        },
        methods: {
            LoadData()
            {
                this.loading = true;

                this.createBreadcrumbs('Administrative Rules', '/Rules/Administrative');

                fetch('/api/Rules',
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            return res.text().then(r => Promise.reject(r));
                    })
                    .then(response =>
                    {
                        this.items = EncodeDatetimes(response);
                    })
                    .catch(error =>
                    {
                        if (error == 404)
                            window.location.href = "/404?path=" + encodeURIComponent(window.location.pathname);
                        else if (error != 302)
                        {
                            let e = '';
                            let ff = true;

                            try
                            {
                                e = String(error).substring(0, 100);
                                ff = (e || '').indexOf('Failed to fetch') > -1;

                                if (!ff && (e || '') == '')
                                    ff = true;
                            }
                            catch (ee) { }

                            if (ff)
                            {
                                window.location.href = "/400?path=" + encodeURIComponent(window.location.pathname) + '&error=' + encodeURIComponent(e);
                            }
                            else
                            {
                                reportError(error);
                                window.location.href = "/500?path=" + encodeURIComponent(window.location.pathname) + '&error=' + encodeURIComponent(e);
                            }
                        }
                    })
                    .finally(() =>
                    {
                        this.loading = false;
                    });
            },
            createBreadcrumbs(route, url)
            {
                this.breadcrumbs = [{
                    to: '/',
                    link: true,
                    text: 'Home',
                }];

                var bci2 = {
                    to: '',
                    link: true,
                    text: '',
                };
                bci2.to = url;
                bci2.text = route;
                bci2.disabled = true;

                this.breadcrumbs.push(bci2);
            },
            shortenCell(str)
            {
                if (str != null)
                {
                    if (str.length > 160)
                    {
                        return str.substring(0, 160);
                    } else
                    {
                        return str;
                    }
                }
            }

        },
        data: function ()
        {
            return {
                loading: false,
                breadcrumbs: [],
                items: [],
                headers: [
                    {
                        text: 'Rule',
                        value: 'Article',
                        Type: 'Rule',
                        width: '15ch'
                    },
                    {
                        text: 'Agency',
                        value: 'Agency',
                        Type: 'Rule',
                    },
                    {
                        text: 'Title',
                        value: 'Catchline',
                        Type: 'Rule',
                        width: '*'
                    },

                ],
                rulefilter: "Active",
            };
        },
        mounted: function ()
        {
            this.LoadData();
        },
        watch: {
            currentRoute()
            {
                this.items = [];
                this.LoadData();
            },
            SessionId: {
                handler()
                {
                    this.LoadData();
                },
            },
        },
        computed: {
            currentRoute: function ()
            {
                return this.$route.path;
            },
            filteredItems: function ()
            {
                if (this.items && this.items.length > 0)
                {
                    if (this.rulefilter != 'All')
                    {
                        return this.items.filter(x => x.Status == this.rulefilter).sort((a, b) => (a.Article > b.Article) ? 1 : -1);
                    }
                    else
                    {
                        return this.items;
                    }
                }
                else
                {
                    return [];
                }
            },
            Title: function ()
            {
                let title = "Administrative Rules";

                return title;
            },
            Description: function ()
            {
                return this.Title;
            }
        },
        metaInfo()
        {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0].replace('rules', 'Rules').replace('administrative', 'Administrative').replace('statutes', 'Statutes').replace('constitution', 'Constitution').replace('codified_laws', 'Codified_Laws').replace('session_laws', 'Session_Laws') }
                ]
            };
        }
    };
</script>
<style></style>